<template>
    <div>
        <b-button class="align-baseline mr-1" title="Print" variant="default" @click="onPrintDamageNotice">
            <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline mr-1" title="Show" variant="default" @click="onShowDamageNotice">
            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline mr-1"
            title="Create Work Order"
            variant="default"
            v-if="!damageNotice.work_order"
            @click="onCreateWorkOrder"
        >
            <font-awesome-icon :icon="['fas', 'file-circle-plus']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline" title="Delete" variant="default" @click="onDeleteDamageNotice">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <damage-notice-modal
            :description="damageNotice.description"
            :modal-id="damageNoticeModalId"
            :photos="damageNotice.photos"
        />
        <modal
            :id="workOrderCreationConfirmationModalId"
            ok-title="Create"
            title="Work Order Creation Confirmation"
            @ok="onConfirmCreationWorkOrder"
        >
            Are you sure you want to create a new work order based on this damage notice?
        </modal>
        <modal
            :id="damageNoticeDeletionConfirmationModalId"
            ok-title="Delete"
            title="Damage Notice Deletion Confirmation"
            @ok="onConfirmDeletionDamageNotice"
        >
            Are you sure you want to delete this damage notice?
        </modal>
    </div>
</template>

<script>
import DamageNoticeModal from '../../common/damage-notice-modal.vue';
import Modal from '../../generic/modal/modal.vue';

export default {
    components: { DamageNoticeModal, Modal },
    data() {
        return {
            damageNotice: null,
            damageNoticeModalId: null,
            isDamageNoticeModalLoading: false,
            workOrderCreationConfirmationModalId: null,
        };
    },
    created() {
        this.damageNotice = this.params.data;
        this.damageNoticeModalId = `damage-notice-modal-id-${this.damageNotice.id}`;
        this.workOrderCreationConfirmationModalId = `work-order-creation-confirmation-modal-id-${this.damageNotice.id}`;
        this.damageNoticeDeletionConfirmationModalId = `damage-notice-deletion-confirmation-modal-id-${this.damageNotice.id}`
    },
    methods: {
        onConfirmCreationWorkOrder() {
            this.params.onCreateWorkOrder();
        },
        onConfirmDeletionDamageNotice() {
            this.params.onDeleteDamageNotice();
        },
        onCreateWorkOrder() {
            this.$bvModal.show(this.workOrderCreationConfirmationModalId);
        },
        onDeleteDamageNotice() {
            this.$bvModal.show(this.damageNoticeDeletionConfirmationModalId);
        },
        onPrintDamageNotice() {
            this.params.onPrintDamageNotice();
        },
        onShowDamageNotice() {
            this.$bvModal.show(this.damageNoticeModalId);
        },
    },
};
</script>
